
    <div class="container" [formGroup]="formGroup">
      <textarea *ngIf="!element.isEditor"
        pInputTextarea
        appSeleniumDirective
        [element]="element"
        [formControlName]="formControlName"
        [placeholder]="element.placeholder"
        [readOnly]="isReadOnly()"
        [style.font-weight]="getFontWeight()"
        (keyup)="keyUp.next($event)"
        (keydown)="keyDown.next($event)"
        tabindex="{{element.tabIndex}}"
        #inputElement
      ></textarea>

      <div
      class="editor-container"
      #editor
      *ngIf="element.isEditor && editorOptions"
      [froalaEditor]="editorOptions"
      [formControlName]="formControlName"
      >
      </div>
    </div>
  